import { OfferSystemController } from '../../libs/offerSystem/OfferSystemController';
import type { Condition } from './conditionsTypes';
import type { OffersGameData, StateProxy } from './offersTypes';
import { OfferLocation, OfferTrigger } from './offersTypes';
import type { OfferSystemData } from '../../libs/offerSystem/OfferSystemHistory';
import { conditions } from './conditions';
import { GameStateProxy } from './GameStateProxy';
import type { OfferDefinition } from '../../libs/offerSystem/offerSystemTypes';
import type { App } from '../App';

export function initOfferSystem(
  app: App,
  offers: OfferDefinition<Condition, OffersGameData>[],
): OfferSystemController<StateProxy, Condition, OffersGameData> {
  return new OfferSystemController({
    conditions,
    getCurrentTime(): number {
      return Date.now();
    },
    locations: Object.values(OfferLocation),
    offers,
    purchaseHistory: app.stateController.getOfferSystemData(),
    saveHandler(data: OfferSystemData): void {
      app.stateController.setOfferSystemData(data);
    },
    state: new GameStateProxy(app),
    supportedLanguages: ['en_US', 'it_IT', 'fr_FR', 'de_DE', 'es_ES', 'pt_PT', 'pl_PL', 'nl_NL', 'ko_KR', 'ja_JP'],
    triggers: Object.values(OfferTrigger),
  });
}
